var exports = {
  "k": "x127c5a35--a32d27--container",
  "i": "x127c5a35--a32d27--main",
};

module.exports = exports;
